import {
  Component,
  ElementRef,
  ChangeDetectorRef,
  HostBinding,
  Input,
  Output,
  EventEmitter,
  inject,
  input,
} from '@angular/core';
import { fromEvent } from 'rxjs';
import { IconNames } from '@shared/enums/icon-names';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { IceBadgeComponent } from '../../../atoms/ice-badge/ice-badge.component';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { IceImgPillComponent } from '@app/shared/components/atoms/ice-img-pill/ice-img-pill.component';

@Component({
  selector: 'app-accordion-header',
  templateUrl: './accordion-header.component.html',
  styleUrls: ['./accordion-header.component.scss'],
  imports: [NgClass, MatIcon, IceBadgeComponent, MatIconButton, MatMenuTrigger, MatMenu, IceImgPillComponent],
})
export class AccordionHeaderComponent {
  private host = inject(ElementRef);
  private cdr = inject(ChangeDetectorRef);

  IconNames = IconNames;

  testId = input.required<string>();
  @Input() icon: string;
  @Input() image: string;
  @Input() imagePillText: string;
  @Input() showImageBackground: boolean;
  @Input() _isOpen = true;
  @Input() showMenu: boolean;
  @Input() disabled: boolean;
  @Input() messageType: 'error' | 'success' | 'warning' | 'neutral' = 'neutral';
  @Input() message: string = '';
  @Output() toggleAccordion: EventEmitter<boolean> = new EventEmitter();
  @Input() tab: string = '0';

  click$ = fromEvent(this.host.nativeElement, 'click');
  rotationState = 'default';

  @Input()
  @HostBinding('class.accordion-open')
  set isOpen(value: boolean) {
    this.rotationState = !value ? 'rotated' : 'default';
    if (this.isOpen !== value) {
      this._isOpen = value;
      this.cdr.markForCheck();
    }
  }

  get isOpen() {
    return this._isOpen;
  }

  get imageBackgroundClass() {
    return this.showImageBackground ? 'background-' + this.messageType : '';
  }
}
